import { Reducer } from "redux";

import defaultState from "../default-state";

// REDUCER - For a given state and action, returns the new state.
// To support time travel, this must not mutate the old state.

export const productFormBreadcrumb: Reducer<ReadonlyArray<Readonly<BreadcrumbItem<ProductFormItemType>>>>
	= (state = defaultState.productFormBreadcrumb, incomingAction: IAction) => {
		switch (incomingAction.type) {
			case "PRODUCT_FORM_DOWN_NAVIGATION":
				const downAction = incomingAction as IProductFormDownNavAction<any>;
				const downIndex = state.findIndex(e => e.entity == downAction.entity.entity);
				return [...state.filter((value, ind) => ind < (downIndex === 1 ? 0 : downIndex))];
			case "PRODUCT_FORM_UP_NAVIGATION":
				const upAction = incomingAction as IProductFormUpNavAction<any>;
				const newItem = { entity: upAction.entity, key: upAction.key, title: upAction.title, text: upAction.text };
				return state.length > 0
					? [...state, newItem]
					: [upAction.previous, newItem];
			case "PRODUCT_FORM_CLEAR_STORE":
				return [];
			default:
				return state;
		}
	};

export const otherLoadedEntities: Reducer<ReadonlyArray<Readonly<{ entity: ProductFormItemType }>>>
	= (state = defaultState.otherLoadedEntities, incomingAction: IAction) => {
		switch (incomingAction.type) {
			case "PRODUCT_FORM_RELATIONSHIP_LOADED":
				const navLoaded = incomingAction as IProductFormRelationshipLoaded<any, any>;
				const navLoadedIndex = state.findIndex(e => e.entity == navLoaded.entity.entity);
				const isArray = Array.isArray(navLoaded.entities);
				const entities = isArray
					? navLoaded.entities
					: [navLoaded.entities];
				if (navLoadedIndex === -1) {
					return [
						...state,
						{
							...navLoaded.entity, // Spread all entity properties
							[navLoaded.parentEntityProperty]: navLoaded.entities, // replacing the new loaded nav property
						},
						...entities,
					];
				}
				const old = state[navLoadedIndex];
				return [
					...state.filter((value, ind) => ind < navLoadedIndex), // Include previous items without change
					{
						...old, // Spread old properties
						...navLoaded.entity, // Spread all entity properties
						[navLoaded.parentEntityProperty]: old[navLoaded.parentEntityProperty] && isArray
							? [...old[navLoaded.parentEntityProperty], ...entities]
							: navLoaded.entities, // replacing the new loaded nav property
					},
					...entities,
					...state.filter((value, ind) => ind > navLoadedIndex), // Include next items without change
				];
			case "PRODUCT_FORM_CLEAR_STORE":
				return [];
			default:
				return state;
		}
	};



// WEBPACK FOOTER //
// ./src/store/products/product-form-nav-reducer.ts